



















import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';
import BodyTable from '@/components/BodyTable.vue';

export default Vue.extend<any, any, any, any>({
	components: {
		StepContent, BackgroundTools, BodyTable,
	},
	data: () => ({
		disected: true,
	}),
});
